import type { WikiArticle } from './wikiArticles';
import { wikiArticles } from './wikiArticles';

// Simplified → Traditional character mapping (comprehensive for this content domain)
const MAP: Record<string, string> = {
  一: '一', 丁: '丁', 七: '七', 万: '萬', 丈: '丈', 三: '三', 上: '上', 下: '下', 不: '不', 与: '與',
  专: '專', 且: '且', 世: '世', 业: '業', 东: '東', 丝: '絲', 两: '兩', 严: '嚴', 个: '個', 中: '中',
  丰: '豐', 串: '串', 临: '臨', 丸: '丸', 丹: '丹', 为: '為', 主: '主', 丽: '麗', 举: '舉', 乃: '乃',
  久: '久', 么: '麼', 义: '義', 之: '之', 乌: '烏', 乎: '乎', 乏: '乏', 乐: '樂', 乔: '喬', 乖: '乖',
  乘: '乘', 九: '九', 也: '也', 习: '習', 乡: '鄉', 书: '書', 买: '買', 乱: '亂', 了: '了', 予: '予',
  争: '爭', 事: '事', 二: '二', 于: '於', 亏: '虧', 云: '雲', 互: '互', 五: '五', 井: '井', 亚: '亞',
  些: '些', 亡: '亡', 交: '交', 亦: '亦', 产: '產', 亩: '畝', 亲: '親', 人: '人', 亿: '億', 仅: '僅',
  今: '今', 介: '介', 从: '從', 仑: '侖', 仓: '倉', 仔: '仔', 仕: '仕', 他: '他', 仗: '仗', 付: '付',
  仙: '仙', 代: '代', 令: '令', 以: '以', 们: '們', 仪: '儀', 仰: '仰', 件: '件', 价: '價', 任: '任',
  份: '份', 仿: '仿', 企: '企', 伊: '伊', 伍: '伍', 伏: '伏', 休: '休', 众: '眾', 优: '優', 伙: '夥',
  会: '會', 伟: '偉', 传: '傳', 伤: '傷', 伦: '倫', 伪: '偽', 似: '似', 但: '但', 位: '位', 低: '低',
  住: '住', 体: '體', 何: '何', 余: '餘', 佛: '佛', 作: '作', 你: '你', 佣: '傭', 佩: '佩', 佳: '佳',
  使: '使', 例: '例', 供: '供', 依: '依', 侠: '俠', 侣: '侶', 侦: '偵', 侧: '側', 侨: '僑', 侮: '侮',
  侯: '侯', 侵: '侵', 便: '便', 促: '促', 俄: '俄', 俊: '俊', 俗: '俗', 保: '保', 信: '信', 俩: '倆',
  修: '修', 俱: '俱', 倡: '倡', 债: '債', 值: '值', 倾: '傾', 假: '假', 偏: '偏', 做: '做', 停: '停',
  健: '健', 偶: '偶', 偷: '偷', 偿: '償', 储: '儲', 傲: '傲', 傻: '傻', 像: '像', 儿: '兒',
  元: '元', 兄: '兄', 充: '充', 先: '先', 光: '光', 克: '克', 免: '免', 兑: '兌', 入: '入', 內: '內',
  全: '全', 公: '公', 六: '六', 兰: '蘭', 共: '共', 关: '關', 兴: '興', 兵: '兵', 其: '其',
  具: '具', 典: '典', 养: '養', 兼: '兼', 兽: '獸', 内: '內', 冈: '岡', 册: '冊', 再: '再', 写: '寫',
  军: '軍', 农: '農', 冠: '冠', 冤: '冤', 冬: '冬', 冰: '冰', 冲: '沖', 决: '決', 况: '況', 冷: '冷',
  准: '準', 净: '淨', 减: '減', 几: '幾', 凡: '凡', 凤: '鳳', 凭: '憑', 凯: '凱', 出: '出', 击: '擊',
  函: '函', 分: '分', 切: '切', 刊: '刊', 刑: '刑', 列: '列', 刘: '劉', 则: '則', 刚: '剛', 创: '創',
  初: '初', 删: '刪', 判: '判', 别: '別', 利: '利', 到: '到', 制: '製', 刷: '刷', 券: '券', 刺: '刺',
  刻: '刻', 剂: '劑', 前: '前', 剑: '劍', 剧: '劇', 剩: '剩', 剪: '剪', 副: '副', 割: '割', 划: '劃',
  力: '力', 办: '辦', 加: '加', 务: '務', 动: '動', 助: '助', 努: '努', 励: '勵', 劲: '勁', 劳: '勞',
  势: '勢', 勤: '勤', 勾: '勾', 包: '包', 化: '化', 北: '北', 医: '醫', 区: '區', 十: '十', 千: '千',
  升: '升', 午: '午', 华: '華', 协: '協', 单: '單', 卖: '賣', 南: '南', 博: '博', 卡: '卡', 卢: '盧',
  卫: '衛', 印: '印', 危: '危', 即: '即', 却: '卻', 卷: '卷', 厂: '廠', 压: '壓', 原: '原', 县: '縣',
  参: '參', 又: '又', 双: '雙', 发: '發', 取: '取', 受: '受', 变: '變', 叙: '敘', 口: '口', 古: '古',
  句: '句', 另: '另', 只: '只', 叫: '叫', 召: '召', 可: '可', 台: '臺', 史: '史', 右: '右', 叶: '葉',
  号: '號', 司: '司', 吃: '吃', 各: '各', 合: '合', 吉: '吉', 吊: '吊', 同: '同', 名: '名', 后: '後',
  向: '向', 吗: '嗎', 君: '君', 听: '聽', 启: '啟', 呢: '呢', 周: '週', 味: '味', 命: '命', 和: '和',
  咖: '咖', 品: '品', 哈: '哈', 响: '響', 哪: '哪', 哦: '哦', 哥: '哥', 哲: '哲', 售: '售', 商: '商',
  啊: '啊', 善: '善', 喜: '喜', 喝: '喝', 喷: '噴', 器: '器', 四: '四', 回: '回', 因: '因', 团: '團',
  困: '困', 围: '圍', 园: '園', 图: '圖', 圆: '圓', 圈: '圈', 国: '國', 圣: '聖', 地: '地', 场: '場',
  坏: '壞', 坐: '坐', 坚: '堅', 坛: '壇', 坝: '壩', 型: '型', 城: '城', 基: '基', 塔: '塔', 填: '填',
  增: '增', 士: '士', 声: '聲', 备: '備', 复: '復', 夏: '夏', 外: '外', 多: '多', 夜: '夜', 够: '夠',
  大: '大', 天: '天', 太: '太', 夫: '夫', 失: '失', 头: '頭', 夹: '夾', 夺: '奪', 奇: '奇', 奉: '奉',
  奋: '奮', 女: '女', 奶: '奶', 她: '她', 好: '好', 如: '如', 妇: '婦', 妈: '媽', 姐: '姐', 始: '始',
  委: '委', 威: '威', 娃: '娃', 娘: '娘', 娱: '娛', 婚: '婚', 婴: '嬰', 子: '子', 孔: '孔', 字: '字',
  存: '存', 孙: '孫', 季: '季', 学: '學', 孩: '孩', 宁: '寧', 它: '它', 宅: '宅', 安: '安', 完: '完',
  宋: '宋', 宏: '宏', 宝: '寶', 实: '實', 宠: '寵', 审: '審', 客: '客', 宣: '宣', 室: '室', 家: '家',
  容: '容', 宿: '宿', 寄: '寄', 密: '密', 富: '富', 寒: '寒', 对: '對', 寻: '尋', 导: '導', 封: '封',
  将: '將', 小: '小', 少: '少', 尔: '爾', 尖: '尖', 尚: '尚', 尤: '尤', 就: '就', 尺: '尺',
  尼: '尼', 尽: '盡', 尾: '尾', 局: '局', 层: '層', 展: '展', 属: '屬', 山: '山', 岛: '島', 峰: '峰',
  峡: '峽', 岗: '崗', 岩: '岩', 岭: '嶺', 崖: '崖', 川: '川', 州: '州', 巡: '巡', 工: '工', 左: '左',
  差: '差', 己: '己', 已: '已', 巴: '巴', 巷: '巷', 市: '市', 布: '布', 师: '師', 希: '希', 帐: '帳',
  帘: '簾', 带: '帶', 帮: '幫', 常: '常', 幅: '幅', 平: '平', 年: '年', 并: '並', 幸: '幸', 干: '幹',
  幼: '幼', 广: '廣', 庄: '莊', 庆: '慶', 床: '床', 序: '序', 应: '應', 店: '店', 庙: '廟', 度: '度',
  座: '座', 庭: '庭', 康: '康', 建: '建', 开: '開', 异: '異', 弃: '棄', 弄: '弄', 式: '式', 引: '引',
  张: '張', 强: '強', 归: '歸', 当: '當', 录: '錄', 形: '形', 影: '影', 往: '往', 待: '待', 很: '很',
  後: '後', 得: '得', 微: '微', 德: '德', 心: '心', 必: '必', 忆: '憶', 志: '志', 忙: '忙', 快: '快',
  念: '念', 忽: '忽', 怀: '懷', 态: '態', 怎: '怎', 思: '思', 急: '急', 性: '性', 总: '總', 恋: '戀',
  恐: '恐', 恒: '恆', 恩: '恩', 息: '息', 您: '您', 悬: '懸', 情: '情', 惊: '驚', 惠: '惠', 想: '想',
  意: '意', 感: '感', 愿: '願', 慈: '慈', 慢: '慢', 懂: '懂', 成: '成', 我: '我', 或: '或', 战: '戰',
  戏: '戲', 户: '戶', 所: '所', 才: '才', 执: '執', 扩: '擴', 扫: '掃', 扬: '揚', 护: '護', 报: '報',
  择: '擇', 拥: '擁', 拦: '攔', 挂: '掛', 挤: '擠', 挥: '揮', 据: '據', 摆: '擺', 摄: '攝', 数: '數',
  断: '斷', 无: '無', 显: '顯', 时: '時', 术: '術', 标: '標', 树: '樹', 桥: '橋', 检: '檢', 欢: '歡',
  步: '步', 每: '每', 气: '氣', 水: '水', 求: '求', 汇: '匯', 汉: '漢', 汤: '湯', 沟: '溝', 浅: '淺',
  测: '測', 济: '濟', 温: '溫', 游: '遊', 满: '滿', 灵: '靈', 灯: '燈', 热: '熱', 爱: '愛', 物: '物',
  特: '特', 独: '獨', 猎: '獵', 王: '王', 环: '環', 现: '現', 理: '理', 电: '電', 画: '畫', 疗: '療',
  症: '症', 癌: '癌', 监: '監', 盖: '蓋', 盘: '盤', 目: '目', 相: '相', 真: '真', 确: '確', 码: '碼',
  礼: '禮', 社: '社', 祝: '祝', 神: '神', 离: '離', 种: '種', 称: '稱', 积: '積', 稳: '穩', 竞: '競',
  简: '簡', 约: '約', 级: '級', 纪: '紀', 网: '網', 线: '線', 终: '終', 组: '組', 经: '經', 结: '結',
  统: '統', 继: '繼', 绿: '綠', 编: '編', 缩: '縮', 繁: '繁', 纠: '糾', 纵: '縱', 纤: '纖', 纸: '紙',
  纹: '紋', 纺: '紡', 纽: '紐', 纯: '純', 纳: '納', 纱: '紗', 纷: '紛', 练: '練', 细: '細', 织: '織',
  绍: '紹', 绑: '綁', 绒: '絨', 绕: '繞', 绘: '繪', 给: '給', 绚: '絢', 络: '絡', 绝: '絕', 绞: '絞',
  续: '續', 绪: '緒', 缆: '纜', 缓: '緩', 缘: '緣', 缜: '縝', 缝: '縫', 缠: '纏', 缪: '繆', 缕: '縷',
  罗: '羅', 羊: '羊', 美: '美', 群: '群', 羽: '羽', 老: '老', 考: '考', 者: '者', 而: '而',
  耕: '耕', 联: '聯', 职: '職', 胜: '勝', 能: '能', 脸: '臉', 脏: '髒', 脑: '腦',
  腰: '腰', 腿: '腿', 自: '自', 至: '至', 舌: '舌', 舍: '捨', 舒: '舒', 舞: '舞', 航: '航',
  船: '船', 色: '色', 艺: '藝', 节: '節', 花: '花', 苏: '蘇', 苗: '苗', 若: '若', 苦: '苦', 英: '英',
  范: '範', 草: '草', 茶: '茶', 药: '藥', 荷: '荷', 获: '獲', 落: '落', 著: '著', 蓝: '藍', 藏: '藏',
  处: '處', 虚: '虛', 虫: '蟲', 蛇: '蛇', 蜂: '蜂', 蜜: '蜜', 行: '行', 街: '街', 表: '表',
  衫: '衫', 被: '被', 补: '補', 装: '裝', 裤: '褲', 要: '要', 见: '見', 观: '觀', 规: '規', 视: '視',
  觉: '覺', 览: '覽', 角: '角', 解: '解', 触: '觸', 言: '言', 记: '記', 讲: '講', 许: '許', 论: '論',
  设: '設', 识: '識', 诉: '訴', 词: '詞', 译: '譯', 试: '試', 诗: '詩', 诚: '誠', 话: '話', 语: '語',
  误: '誤', 说: '說', 请: '請', 诸: '諸', 读: '讀', 课: '課', 谁: '誰', 调: '調', 谈: '談', 谊: '誼',
  谋: '謀', 谎: '謊', 谢: '謝', 谣: '謠', 象: '象', 贝: '貝', 负: '負', 贡: '貢', 财: '財', 责: '責',
  贤: '賢', 败: '敗', 货: '貨', 质: '質', 购: '購', 贯: '貫', 贱: '賤', 贴: '貼', 贵: '貴', 费: '費',
  贸: '貿', 贺: '賀', 资: '資', 贾: '賈', 宾: '賓', 赐: '賜', 赏: '賞', 赔: '賠', 赖: '賴', 赚: '賺',
  赛: '賽', 赞: '讚', 赠: '贈', 赢: '贏', 走: '走', 起: '起', 越: '越', 趣: '趣', 足: '足', 跟: '跟',
  跨: '跨', 路: '路', 跳: '跳', 身: '身', 车: '車', 轨: '軌', 转: '轉', 轮: '輪', 软: '軟', 轻: '輕',
  载: '載', 较: '較', 辅: '輔', 辈: '輩', 辉: '輝', 辑: '輯', 输: '輸', 辨: '辨', 边: '邊', 达: '達',
  迁: '遷', 过: '過', 迈: '邁', 迎: '迎', 运: '運', 近: '近', 返: '返', 还: '還', 这: '這', 进: '進',
  远: '遠', 违: '違', 连: '連', 迟: '遲', 选: '選', 适: '適', 追: '追', 退: '退', 送: '送', 逃: '逃',
  逆: '逆', 透: '透', 逐: '逐', 递: '遞', 途: '途', 通: '通', 遇: '遇', 遍: '遍', 道: '道', 遗: '遺',
  邀: '邀', 那: '那', 邮: '郵', 邻: '鄰', 部: '部', 都: '都', 酒: '酒', 配: '配', 里: '裡', 重: '重',
  野: '野', 量: '量', 金: '金', 针: '針', 钉: '釘', 钓: '釣', 钙: '鈣', 钟: '鐘', 钢: '鋼', 钥: '鑰',
  钦: '欽', 钱: '錢', 钻: '鑽', 铁: '鐵', 铂: '鉑', 铃: '鈴', 铅: '鉛', 铜: '銅', 铝: '鋁', 银: '銀',
  铸: '鑄', 铺: '鋪', 链: '鏈', 锁: '鎖', 锋: '鋒', 锐: '銳', 错: '錯', 锡: '錫', 锣: '鑼', 锤: '錘',
  键: '鍵', 镇: '鎮', 镜: '鏡', 长: '長', 门: '門', 闪: '閃', 闭: '閉', 问: '問', 闯: '闖', 间: '間',
  闷: '悶', 闹: '鬧', 闻: '聞', 阅: '閱', 队: '隊', 阳: '陽', 阴: '陰', 阵: '陣', 阶: '階', 际: '際',
  陆: '陸', 陈: '陳', 险: '險', 随: '隨', 隐: '隱', 难: '難', 雨: '雨', 雪: '雪', 零: '零', 雾: '霧',
  需: '需', 静: '靜', 非: '非', 靠: '靠', 面: '面', 革: '革', 鞋: '鞋', 顶: '頂', 项: '項', 顺: '順',
  须: '須', 顽: '頑', 顾: '顧', 领: '領', 题: '題', 额: '額', 风: '風', 飞: '飛', 食: '食', 饭: '飯',
  饮: '飲', 饰: '飾', 饱: '飽', 馆: '館', 首: '首', 香: '香', 马: '馬', 驾: '駕', 骑: '騎',
  骨: '骨', 高: '高', 鱼: '魚', 鸟: '鳥', 鸡: '雞', 鸣: '鳴', 鸭: '鴨', 鹰: '鷹', 鹿: '鹿', 麦: '麥',
  麻: '麻', 黄: '黃', 黑: '黑', 鼓: '鼓', 鼻: '鼻', 齐: '齊', 齿: '齒', 龙: '龍',
};

// Additional common conversions not ambiguous (single-char, context-free)
const EXTRA: Record<string, string> = {
  丰: '豐', 乐: '樂', 乔: '喬', 买: '買', 乱: '亂', 争: '爭', 于: '於', 亏: '虧', 云: '雲', 亚: '亞',
  产: '產', 亲: '親', 亿: '億', 仅: '僅', 仑: '侖', 仓: '倉', 仪: '儀', 价: '價', 众: '眾', 优: '優',
  伙: '夥', 会: '會', 伟: '偉', 传: '傳', 伤: '傷', 伦: '倫', 伪: '偽', 体: '體', 余: '餘', 佣: '傭',
  侠: '俠', 侣: '侶', 侦: '偵', 侧: '側', 侨: '僑', 俩: '倆', 债: '債', 倾: '傾', 偿: '償', 储: '儲',
  儿: '兒', 兑: '兌', 兰: '蘭', 关: '關', 兴: '興', 养: '養', 兽: '獸', 冈: '岡', 册: '冊', 写: '寫',
  军: '軍', 农: '農', 决: '決', 况: '況', 净: '淨', 减: '減', 凤: '鳳', 凭: '憑', 凯: '凱', 击: '擊',
  刘: '劉', 则: '則', 刚: '剛', 创: '創', 删: '刪', 别: '別', 剂: '劑', 剑: '劍', 剧: '劇', 划: '劃',
  办: '辦', 务: '務', 动: '動', 励: '勵', 劲: '勁', 劳: '勞', 势: '勢', 医: '醫', 区: '區', 华: '華',
  协: '協', 单: '單', 卖: '賣', 卢: '盧', 卫: '衛', 县: '縣', 参: '參', 双: '雙', 发: '發', 变: '變',
  叙: '敘', 台: '臺', 叶: '葉', 号: '號', 后: '後', 吗: '嗎', 听: '聽', 启: '啟', 周: '週', 响: '響',
  喷: '噴', 团: '團', 围: '圍', 园: '園', 图: '圖', 圆: '圓', 国: '國', 圣: '聖', 场: '場', 坏: '壞',
  坚: '堅', 坛: '壇', 坝: '壩', 声: '聲', 备: '備', 复: '復', 够: '夠', 头: '頭', 夹: '夾', 夺: '奪',
  奋: '奮', 妇: '婦', 妈: '媽', 娱: '娛', 婴: '嬰', 孙: '孫', 学: '學', 宁: '寧', 宝: '寶', 实: '實',
  宠: '寵', 审: '審', 对: '對', 寻: '尋', 导: '導', 将: '將', 尔: '爾', 尽: '盡', 层: '層', 属: '屬',
  岛: '島', 峡: '峽', 岗: '崗', 岭: '嶺', 师: '師', 帐: '帳', 帘: '簾', 带: '帶', 帮: '幫', 庄: '莊',
  庆: '慶', 应: '應', 庙: '廟', 开: '開', 异: '異', 弃: '棄', 张: '張', 强: '強', 归: '歸', 当: '當',
  录: '錄', 忆: '憶', 怀: '懷', 态: '態', 总: '總', 恋: '戀', 恒: '恆', 悬: '懸', 惊: '驚', 愿: '願',
  战: '戰', 戏: '戲', 户: '戶', 执: '執', 扩: '擴', 扫: '掃', 扬: '揚', 护: '護', 报: '報', 择: '擇',
  拥: '擁', 拦: '攔', 挂: '掛', 挤: '擠', 挥: '揮', 据: '據', 摆: '擺', 摄: '攝', 数: '數', 断: '斷',
  无: '無', 显: '顯', 时: '時', 术: '術', 标: '標', 树: '樹', 桥: '橋', 检: '檢', 欢: '歡', 气: '氣',
  汇: '匯', 汉: '漢', 汤: '湯', 沟: '溝', 浅: '淺', 测: '測', 济: '濟', 温: '溫', 游: '遊', 满: '滿',
  灵: '靈', 灯: '燈', 热: '熱', 爱: '愛', 独: '獨', 猎: '獵', 环: '環', 现: '現', 电: '電', 画: '畫',
  疗: '療', 监: '監', 盖: '蓋', 盘: '盤', 确: '確', 码: '碼', 礼: '禮', 离: '離', 种: '種', 称: '稱',
  积: '積', 稳: '穩', 竞: '競', 简: '簡', 约: '約', 级: '級', 纪: '紀', 网: '網', 线: '線', 终: '終',
  组: '組', 经: '經', 结: '結', 统: '統', 继: '繼', 绿: '綠', 编: '編', 缩: '縮', 纠: '糾', 纵: '縱',
  纤: '纖', 纸: '紙', 纹: '紋', 纺: '紡', 纽: '紐', 纯: '純', 纳: '納', 纱: '紗', 纷: '紛', 练: '練',
  细: '細', 织: '織', 绍: '紹', 绑: '綁', 绒: '絨', 绕: '繞', 绘: '繪', 给: '給', 绚: '絢', 络: '絡',
  绝: '絕', 绞: '絞', 续: '續', 绪: '緒', 缆: '纜', 缓: '緩', 缘: '緣', 缝: '縫', 缠: '纏', 缪: '繆',
  缕: '縷', 罗: '羅', 联: '聯', 职: '職', 胜: '勝', 脸: '臉', 脏: '髒', 脑: '腦', 艺: '藝', 节: '節',
  苏: '蘇', 范: '範', 药: '藥', 获: '獲', 蓝: '藍', 处: '處', 虚: '虛', 虫: '蟲', 补: '補', 装: '裝',
  裤: '褲', 见: '見', 观: '觀', 规: '規', 视: '視', 觉: '覺', 览: '覽', 触: '觸', 记: '記', 讲: '講',
  许: '許', 论: '論', 设: '設', 识: '識', 诉: '訴', 词: '詞', 译: '譯', 试: '試', 诗: '詩', 诚: '誠',
  话: '話', 语: '語', 误: '誤', 说: '說', 请: '請', 诸: '諸', 读: '讀', 课: '課', 谁: '誰', 调: '調',
  谈: '談', 谊: '誼', 谋: '謀', 谎: '謊', 谢: '謝', 谣: '謠', 贝: '貝', 负: '負', 贡: '貢', 财: '財',
  责: '責', 贤: '賢', 败: '敗', 货: '貨', 质: '質', 购: '購', 贯: '貫', 贱: '賤', 贴: '貼', 贵: '貴',
  费: '費', 贸: '貿', 贺: '賀', 资: '資', 贾: '賈', 宾: '賓', 赐: '賜', 赏: '賞', 赔: '賠', 赖: '賴',
  赚: '賺', 赛: '賽', 赞: '讚', 赠: '贈', 赢: '贏', 车: '車', 轨: '軌', 转: '轉', 轮: '輪', 软: '軟',
  轻: '輕', 载: '載', 较: '較', 辅: '輔', 辈: '輩', 辉: '輝', 辑: '輯', 输: '輸', 边: '邊', 达: '達',
  迁: '遷', 过: '過', 迈: '邁', 运: '運', 还: '還', 这: '這', 进: '進', 远: '遠', 违: '違', 连: '連',
  迟: '遲', 选: '選', 适: '適', 递: '遞', 遗: '遺', 邮: '郵', 邻: '鄰', 里: '裡', 针: '針', 钉: '釘',
  钓: '釣', 钙: '鈣', 钟: '鐘', 钢: '鋼', 钥: '鑰', 钦: '欽', 钱: '錢', 钻: '鑽', 铁: '鐵', 铂: '鉑',
  铃: '鈴', 铅: '鉛', 铜: '銅', 铝: '鋁', 银: '銀', 铸: '鑄', 铺: '鋪', 链: '鏈', 锁: '鎖', 锋: '鋒',
  锐: '銳', 错: '錯', 锡: '錫', 锣: '鑼', 锤: '錘', 键: '鍵', 镇: '鎮', 镜: '鏡', 长: '長', 门: '門',
  闪: '閃', 闭: '閉', 问: '問', 闯: '闖', 间: '間', 闷: '悶', 闹: '鬧', 闻: '聞', 阅: '閱', 队: '隊',
  阳: '陽', 阴: '陰', 阵: '陣', 阶: '階', 际: '際', 陆: '陸', 陈: '陳', 险: '險', 随: '隨', 隐: '隱',
  难: '難', 雾: '霧', 静: '靜', 顶: '頂', 项: '項', 顺: '順', 须: '須', 顽: '頑', 顾: '顧', 领: '領',
  题: '題', 额: '額', 风: '風', 飞: '飛', 饭: '飯', 饮: '飲', 饰: '飾', 饱: '飽', 馆: '館', 马: '馬',
  驾: '駕', 骑: '騎', 鱼: '魚', 鸟: '鳥', 鸡: '雞', 鸣: '鳴', 鸭: '鴨', 鹰: '鷹', 麦: '麥', 黄: '黃',
  齐: '齊', 齿: '齒', 龙: '龍', 岁: '歲', 岂: '豈', 账: '賬', 预: '預', 验: '驗', 详: '詳', 营: '營', 该: '該', 认: '認',
};

function toTraditional(input: string): string {
  let result = '';
  for (const ch of input) {
    result += MAP[ch] ?? EXTRA[ch] ?? ch;
  }
  return result;
}

function convertArticle(a: WikiArticle): WikiArticle {
  return {
    ...a,
    title: toTraditional(a.title),
    metaTitle: toTraditional(a.metaTitle),
    metaDescription: toTraditional(a.metaDescription),
    metaKeywords: toTraditional(a.metaKeywords),
    category: toTraditional(a.category),
    subcategory: toTraditional(a.subcategory),
    excerpt: toTraditional(a.excerpt),
    content: toTraditional(a.content),
    readTime: toTraditional(a.readTime),
    tags: a.tags.map((t) => toTraditional(t)),
    author: toTraditional(a.author),
    authorRole: toTraditional(a.authorRole),
    faq: a.faq.map((f) => ({ question: toTraditional(f.question), answer: toTraditional(f.answer) })),
  };
}

// 新文章「產崽季 vs 渡河季」提供完整、自然的繁體中文覆寫，
// 不依賴逐字轉換，確保標題、摘要、正文、FAQ 與 JSON-LD 均為繁體。
const article16ZhTw: WikiArticle = {
  slug: 'tanzania-calving-vs-river-crossing',
  title: '2026坦桑尼亞產崽季和渡河季怎麼選？塞倫蓋蒂兩大名場面深度對比',
  metaTitle: '2026坦桑尼亞產崽季vs渡河季怎麼選？塞倫蓋蒂深度對比 | 自由曠野旅行',
  metaDescription: '2026年去坦桑尼亞看動物大遷徙，產崽季和渡河季怎麼選？自由曠野旅行從時間、核心區域、野生動物觀感、拍照風格、預算與適合人群等維度，深度對比塞倫蓋蒂兩大名場面，幫你避開常見誤區，選對出行窗口。',
  metaKeywords: '坦桑尼亞Safari,塞倫蓋蒂,產崽季,渡河季,天國之渡,恩杜圖,馬拉河,動物大遷徙,坦桑尼亞怎麼選',
  category: '非洲百科',
  subcategory: 'Safari攻略',
  excerpt: '動物大遷徙不只是角馬過河。產崽季代表新生，渡河季直面死亡，兩者是塞倫蓋蒂完全相悖的生命敘事。自由曠野旅行從時間、核心區域、觀感、拍照、預算與適合人群等維度深度對比，幫你選對真正契合期待的出行窗口。',
  content: `<p class="text-base md:text-lg leading-[1.8] mb-6">很多人總以為，動物大遷徙＝角馬過河。但其實——那只是大遷徙的一幕，動物一年四季都在遷徙，草原從不空。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">產崽季與渡河季，是這場千萬生靈循環裡，兩種完全相悖的生命敘事。一個代表新生，一個直面死亡；一個綠意溫柔，一個蒼茫壯闊。沒有絕對的更好，只有更契合你期待的東非曠野。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/b45b105a-da5c-4eb1-a703-13e4fc0a2342_compressed_safari-13-tanzania-calving-vs-river-crossing-img-001-28f14b9fbb.webp" alt="動物大遷徙全年路線地圖" class="w-full h-auto object-cover" /></div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">一、兩大季節基礎資訊一覽</h2>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">🐣 產崽季｜每年 1 月下旬–3 月上旬</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6"><strong>📍 核心區域：塞倫蓋蒂南部・恩杜圖 Ndutu</strong> 百萬角馬、斑馬集結在南部短草平原。短短一個多月，近 50 萬頭角馬幼崽集中降生，每日約 8000 隻小角馬來到草原。新生幼崽是天然的獵物糧倉，獅群、獵豹、花豹、斑鬣狗全員活躍，捕獵頻次達到全年頂峰。</p>
<ul class="list-disc list-inside space-y-3 text-base md:text-lg leading-[1.8] text-[#1a2e10] mb-6">
  <li><strong>✅ 景觀：</strong>雨季過後，草原鋪滿嫩綠色青草，雲層層次豐富，出片氛圍感極強。</li>
  <li><strong>✅ 遊客密度：</strong>中等，低於 7–9 月渡河旺季，觀景車輛爭搶機位的情況很少。</li>
  <li><strong>✅ 預算：</strong>野奢營地價格適中，不需要提前 12 個月搶房。</li>
  <li><strong>⚠️ 注意：</strong>午後偶有短時陣雨；3 月下旬逐步進入長雨季，不建議出行。</li>
</ul>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">🌊 渡河季｜每年 7–10 月</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6"><strong>📍 核心區域：塞倫蓋蒂北部 Kogatende、馬拉河沿岸</strong> 獸群一路向北遷徙，直面最大阻礙——馬拉河。潛伏河中的尼羅鱷靜靜守候，成千上萬角馬、斑馬縱身躍入河水，上演世人熟知的「天國之渡」。除馬拉河之外，6–7 月西部走廊格魯梅蒂河會迎來首輪渡河，規模更小、遊客更少，適合不想擠人群的旅行者。</p>
<ul class="list-disc list-inside space-y-3 text-base md:text-lg leading-[1.8] text-[#1a2e10] mb-6">
  <li><strong>✅ 景觀：</strong>旱季金黃稀樹草原，草木枯黃，動物集中在水源附近，遠距離更容易發現獸群。</li>
  <li><strong>✅ 遊客密度：</strong>全年頂峰，全球攝影愛好者集中到訪，核心渡河點車輛較多。</li>
  <li><strong>✅ 預算：</strong>全線漲價，熱門河畔野奢營地，強烈建議提前 9–12 個月預定。</li>
  <li><strong>⚠️ 注意：</strong>渡河無法百分百保證！受降雨、獸群移動節奏影響，有可能等候 2–3 天才遇見大規模渡河。</li>
</ul>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">二、核心維度全面對比</h2>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">1. 野生動物觀感</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6"><strong>產崽季</strong> 畫面兼具溫柔與殘酷。隨處可見蹣跚學步的小角馬、小斑馬，經常遇見獅子幼崽、獵豹家庭。你能看見生命誕生的瞬間，也會目睹殘酷的自然法則。捕食鏡頭出現機率極高，是大貓愛好者、生態攝影師的黃金窗口。獸群分佈相對集中在恩杜圖開闊平原，視野通透。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6"><strong>渡河季</strong> 強視覺衝擊、史詩氛圍感拉滿。數萬生靈同時奔騰、涉水，塵土與河水交織，震撼感無可替代。但日常巡遊遇見小型動物幼崽的機率偏低；遊獵看點，更多聚焦遷徙大軍與渡河名場面。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">2. 拍照風格</h3>
<ul class="list-disc list-inside space-y-3 text-base md:text-lg leading-[1.8] text-[#1a2e10] mb-6">
  <li><strong>▫️產崽季：</strong>綠色草原、多雲光影，治癒系生態大片，萌系野生動物、家庭動物素材豐富。</li>
  <li><strong>▫️渡河季：</strong>金黃荒原、遼闊遠景，宏大敘事感，適合拍攝大規模獸群、戲劇性渡河場面。</li>
</ul>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">3. 容易踩坑的常見誤區</h3>
<ul class="list-disc list-inside space-y-3 text-base md:text-lg leading-[1.8] text-[#1a2e10] mb-6">
  <li><strong>❌ 誤區 1：產崽季只有小動物，看不到大遷徙</strong> 糾正：恩杜圖本身就是遷徙環線起點，百萬獸群常年在此聚集，規模足夠壯觀。</li>
  <li><strong>❌ 誤區 2：7–9 月去塞倫蓋蒂，一定能看見馬拉河渡河</strong> 糾正：獸群移動充滿不確定性，無法保證 100% 看到。時間充裕，才能提升遇見機率。</li>
</ul>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">三、自由曠野旅行｜精準人群推薦方案</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">如果你：</p>
<ul class="list-disc list-inside space-y-3 text-base md:text-lg leading-[1.8] text-[#1a2e10] mb-6">
  <li>喜歡柔和綠意風光，偏好自然生態、動物幼崽畫面；</li>
  <li>不喜歡人山人海，想要更加靜謐、沉浸式的 Safari；</li>
  <li>預算有限，希望體驗高端野奢，但避開全年最高價。</li>
</ul>
<p class="text-base md:text-lg leading-[1.8] mb-6">👉 優先選擇<strong>【產崽季】</strong></p>
<p class="text-base md:text-lg leading-[1.8] mb-6">如果你：</p>
<ul class="list-disc list-inside space-y-3 text-base md:text-lg leading-[1.8] text-[#1a2e10] mb-6">
  <li>一生一次清單打卡，執著想要親眼見證「天國之渡」；</li>
  <li>攝影愛好者，追求宏大、有衝擊力的遷徙大片；</li>
  <li>時間充裕，可以預留至少 2-3 晚塞倫蓋蒂北部，耐心等候渡河；</li>
  <li>能夠接受更高住宿成本與較多遊客。</li>
</ul>
<p class="text-base md:text-lg leading-[1.8] mb-6">👉 優先選擇<strong>【渡河季】</strong></p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">四、專業 Safari 機構如何幫助遊客選擇時間？</h2>
<p class="text-base md:text-lg leading-[1.8] mb-6">自由曠野旅行長期深耕坦桑尼亞 Safari 線路，核心團隊擁有十餘年非洲目的地實地考察經驗，多次踏訪塞倫蓋蒂全境，深度掌握遷徙全年移動規律，會根據不同季節的生態變化定製最優路線。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f467331d-1c39-4156-a6eb-379924e25a6d_compressed_safari-13-tanzania-calving-vs-river-crossing-img-002-f9c4db4a88.webp" alt="自由曠野旅行創始人考察過的部分野奢酒店" class="w-full h-auto object-cover" /></div>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">✅ 一線野奢營地直簽資源，旺季優先鎖房</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">與 Singita、One Nature、Lemala 等野奢營地建立長期合作。渡河旺季馬拉河觀景帳篷、產崽季恩杜圖稀缺營地房源，擁有優先預定權限，極大降低旺季一房難求、被迫更換營地的風險。與&amp;Beyond、Wilderness 等營地品牌直簽，讓客戶用高性價比享受頂級野奢。</p>
<div class="my-8 rounded-xl overflow-hidden"><img src="https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/3e7e41de-4cef-4c1b-93ab-fe11f960cc3e_compressed_safari-13-tanzania-calving-vs-river-crossing-img-003-f7dce55b10.webp" alt="自由曠野旅行與部分野奢酒店直簽證明" class="w-full h-auto object-cover" /></div>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">✅ 千人千面定製路線，拒絕模板化行程</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">充分區分不同旅行者核心訴求，一對一專業定製。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">✅ 優選本土資深持證嚮導，提升觀獸機率</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">合作嚮導常年駐守塞倫蓋蒂，熟悉動物活動軌跡；越野車輛不限行駛里程，遇見動物可以隨時停留，不用跟隨大眾車隊趕行程。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">✅ 全流程一站式落地保障</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">統籌國際航班、坦桑內陸輕型飛機、國家公園門票、全程用車、住宿銜接，合理規劃南北長途轉場，減少無效趕路；7×24 小時境內外雙語管家在線，從容應對天氣、航班、獸群變動等各類突發狀況。</p>

<h3 class="text-xl font-bold text-[#1a2e10] mt-8 mb-4">✅ 客觀中立出行建議，不盲目推銷時段</h3>
<p class="text-base md:text-lg leading-[1.8] mb-6">我們不會一味推崇熱度更高的渡河季。結合你的假期時長、同行成員身體條件、攝影需求與預算，客觀分析兩種季節利弊，推薦真正適配你的出行窗口，拒絕流水線推銷。</p>
<p class="text-base md:text-lg leading-[1.8] mb-6">依託目的地資源整合與長期野外經驗，避開普通遊客容易踩中的季節、營地、路線陷阱，讓大家收穫契合期待的 Safari 體驗。</p>`,
  image: 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/b45b105a-da5c-4eb1-a703-13e4fc0a2342_compressed_safari-13-tanzania-calving-vs-river-crossing-img-001-28f14b9fbb.webp',
  readTime: '8分鐘',
  tags: ['坦桑尼亞', '塞倫蓋蒂', '產崽季', '渡河季', '天國之渡', 'Safari攻略'],
  date: '2026-09-15',
  author: 'EVAN',
  authorRole: '資深旅行定製師',
  faq: [
    { question: '產崽季和渡河季分別是什麼時候？', answer: '產崽季是每年 1 月下旬到 3 月上旬，獸群集中在塞倫蓋蒂南部恩杜圖短草平原集中產崽；渡河季是每年 7 到 10 月，獸群抵達塞倫蓋蒂北部及馬拉河沿岸，上演「天國之渡」。' },
    { question: '想看動物幼崽和捕獵，選哪個季節？', answer: '優先選擇產崽季。近 50 萬頭角馬幼崽集中降生，獅群、獵豹、花豹、斑鬣狗全員活躍，捕獵頻次達到全年頂峰，是大貓愛好者和生態攝影師的黃金窗口。' },
    { question: '渡河季一定能看到馬拉河渡河嗎？', answer: '不能百分百保證。獸群移動受降雨、水位和遷徙節奏影響，有可能等候 2–3 天才遇見大規模渡河，建議預留至少 2-3 晚塞倫蓋蒂北部耐心等候。' },
    { question: '第一次去坦桑尼亞 Safari，產崽季和渡河季怎麼選？', answer: '喜歡綠意風光、靜謐沉浸、預算有限可選產崽季；一生一次執著看「天國之渡」、追求宏大攝影大片、時間充裕且能接受高成本可選渡河季。' },
  ],
};

export const wikiArticlesZhTw: WikiArticle[] = wikiArticles
  .map(convertArticle)
  .map((a) => (a.slug === 'tanzania-calving-vs-river-crossing' ? article16ZhTw : a));